var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transactions-list',{ref:"transactionsList",attrs:{"data-func":_vm.getTransactions,"show-user":true}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/players/player/trans-bets.vue?vue&type=template&id=42b02bb1&scoped=true
// module id = Xx0t
// module chunks = 0